import { useEffect, useState } from 'react';

// ─────────────────────────────────────────────────────────────────────────────
// F8 (paridad demo, H-97) — el demo detecta el layout frontline móvil con
// `window.matchMedia('(max-width: 768px)')` + un listener 'change' (PlataformaPage.tsx :
// 84-100), no con CSS puro, porque además de reestilar tiene que cambiar de SECCIÓN
// (mainSection/recoView). El integrado necesita la misma detección reactiva por JS para
// decidir el modifier `.plataforma-shell--frontline` y la clase `body.frontline-mobile-mode`
// — ver AppLayout.tsx.
// ─────────────────────────────────────────────────────────────────────────────

/** Reactivo: true mientras el viewport cumpla `query` (misma sintaxis que matchMedia). */
export function useMediaQuery(query: string): boolean {
  const [matches, setMatches] = useState(() =>
    typeof window !== 'undefined' && typeof window.matchMedia === 'function'
      ? window.matchMedia(query).matches
      : false,
  );

  useEffect(() => {
    if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') return;
    const mq = window.matchMedia(query);
    const handleChange = (e: MediaQueryListEvent) => setMatches(e.matches);
    setMatches(mq.matches);
    mq.addEventListener('change', handleChange);
    return () => mq.removeEventListener('change', handleChange);
  }, [query]);

  return matches;
}

/** Paridad literal con el breakpoint del demo (PlataformaPage.tsx : 85, `max-width: 768px`). */
export function useIsMobileViewport(): boolean {
  return useMediaQuery('(max-width: 768px)');
}

/** Punto de corte de teléfono, compartido por el dashboard personal. */
export const MOBILE_QUERY = '(max-width: 600px)';

export function useIsMobile(): boolean {
  return useMediaQuery(MOBILE_QUERY);
}

export default useMediaQuery;
